import React from 'react';
import * as MyCells from '../../../utils/Cells';
import ActionMenu from '../../common/action/ActionMenu';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../common/filters/DateRangeColumnFilter';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../common/filters/TextColumnFilter';

export const columns = (refresh, selectedPartner) => {
    return [
        {
            Header: 'Dátum',
            accessor: 'date',
            id: 'date',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Típus',
            accessor: 'balanceRowTypeLabel',
            id: 'balanceRowTypeLabel',
            show: true,
            className: 'partnerTypeColumn',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
        },
        {
            Header: 'Megnevezés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Előírás',
            accessor: 'inAmount',
            id: 'inAmount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Kifizetés',
            accessor: 'outAmount',
            id: 'outAmount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Záróegyenleg',
            accessor: 'balance',
            id: 'balance',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'balance'} refresh={refresh} selectedPartner={selectedPartner} />,
            id: 'menu',
            headerClassName: 'actions',
            className: 'actions',
            show: true,
        },
    ]
}